import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';

const useRoles = () => {
  let [result, setResult] = useState({});
  let ROLE_BANK_STAFF = useSelector((state) => state?.auth?.isBankStaff);
  let ROLE_FSC = useSelector((state) => state?.auth?.isFSC);
  let ROLE_EDITOR;
  let IRIS = false;
  let { leadId } = useParams();
  let username = useSelector((state) => state?.auth?.name);
  let bankStaffCode = useSelector((state) => state?.leads?.byIds?.[leadId]?.bankStaffCode);
  let fscCode = useSelector((state) => state?.leads?.byIds?.[leadId]?.fscCode);
  let refNo = useSelector((state) => state?.leads?.byIds?.[leadId]?.refNo);
  let flag = useSelector((state) => state?.leads?.byIds?.[leadId]?.flag);
  let status = useSelector((state) => state?.leads?.byIds?.[leadId]?.status);

  useEffect(() => {
    ROLE_EDITOR =
      !leadId ||
      (ROLE_BANK_STAFF &&
        (bankStaffCode === username || !bankStaffCode) &&
        (flag === 'NEW' || !status || status === 'P')) ||
      (ROLE_FSC && fscCode === username && (!status || status === 'P'));
    IRIS = refNo?.includes('IRC');

    setResult({
      ROLE_BANK_STAFF,
      ROLE_FSC,
      ROLE_EDITOR,
      IRIS,
    });
  }, [bankStaffCode, fscCode, ROLE_FSC, ROLE_BANK_STAFF, username, refNo, status, flag]);

  return result;
};

export default useRoles;
